import { Typography } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles(() => ({
  customStyles: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '15px',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
  },
  requiredStyle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '15px',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
}));
const PopupText = (props) => {
  const classes = useStyles();
  return (
    <Typography className={props.required ? classes.requiredStyle : classes.customStyles}>{props.text}</Typography>
  );
};

export default PopupText;
